import { render, staticRenderFns } from "./DokumentModal.vue?vue&type=template&id=199e28d0"
import script from "./DokumentModal.vue?vue&type=script&lang=js"
export * from "./DokumentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports